import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../components/Input';
import Dropdown from '../../../../components/Dropdown';
import { VALIDATION_FIELD_MAPPING, STATUS } from '../../../../utils/appConstant';
import { ListFilters } from '../../../../interfaces/template.interface';

interface FilterProps {
    status: any[];
    allStatus: any[];
    dropdownSearchData: any;
    initialFilters?: ListFilters;
    onFilterChange: (filters: ListFilters) => void;
    onDropdownSearchChange: (e: any, name: string) => void;
}

const Filters: React.FC<FilterProps> = ({
    status,
    allStatus,
    dropdownSearchData,
    initialFilters,
    onFilterChange,
    onDropdownSearchChange,
}) => {
    const { t } = useTranslation();

    const [filters, setFilters] = useState<ListFilters>(
        initialFilters || {
            searchText: '',
            status: STATUS.active,
        }
    );

    useEffect(() => {
        if (initialFilters) {
            setFilters(initialFilters);
        }
    }, [initialFilters]);

    const handleInputChange = useCallback(
        (event: any, name: string) => {
            setFilters((prev) => {
                return {
                    ...prev,
                    [name]: event.target.value,
                };
            });

            if (name !== VALIDATION_FIELD_MAPPING.searchText) {
                onFilterChange({ ...filters, [name]: event.target.value });
            }
        },
        [filters, onFilterChange]
    );

    const handleKeyDown = useCallback(
        (e: any) => {
            if (e.key === 'Enter') {
                onFilterChange(filters);
            }
        },
        [filters, onFilterChange]
    );

    const handleOnBlur = useCallback(
        (e: any) => {
            onFilterChange(filters);
        },
        [filters, onFilterChange]
    );

    return (
        <div className="row mb-6">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-9 col-sm-12">
                                <Input
                                    type="search"
                                    id={VALIDATION_FIELD_MAPPING.searchText}
                                    name={VALIDATION_FIELD_MAPPING.searchText}
                                    placeholder={
                                        t('templates.list.pageTexts.filters.searchPlaceholder')
                                    }
                                    value={filters.searchText}
                                    onBlur={handleOnBlur}
                                    onKeyDown={handleKeyDown}
                                    onChange={(e) => handleInputChange(e, VALIDATION_FIELD_MAPPING.searchText)}
                                />
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <Dropdown
                                    values={
                                        filters.status && filters.status.toString().trim()
                                            ? [String(filters.status)]
                                            : []
                                    }
                                    options={(status || []).map((item: any) => ({
                                        label: item.name,
                                        value: String(item.id),
                                    }))}
                                    allOptions={(allStatus || []).map((item: any) => ({
                                        label: item.name,
                                        value: String(item.id),
                                    }))}
                                    id={VALIDATION_FIELD_MAPPING.status}
                                    name={VALIDATION_FIELD_MAPPING.status}
                                    searchText={dropdownSearchData.status}
                                    onSearch={onDropdownSearchChange}
                                    placeholder={
                                        t('templates.list.pageTexts.filters.selectStatus')
                                    }
                                    label={t('templates.list.pageTexts.filters.status')}
                                    onChange={(e: any) => {
                                        const value = Array.isArray(e.target?.value)
                                            ? e.target.value[0]
                                            : e.target?.value || '';
                                        const fakeEvent = { target: { value } };
                                        handleInputChange(fakeEvent, VALIDATION_FIELD_MAPPING.status);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Filters;
